import {
    BookOutlined,
    RightOutlined
} from "@ant-design/icons/lib";
import React, { useContext, useEffect, useState } from "react";
import { Layout } from "antd";
import UserLoginContext from "../../../context/userLoginContext";
import { Link, Outlet, useLocation } from "react-router-dom";
import '../../../styles/component/leave-styles.scss'
import server from "../../../server";
import { LeaveContext } from "../leaves/common/leaveContext";

export interface ISupervisor {
    empId: string,
    isSupervisor: boolean
}


const leaveSidebarItems: any = {
    admin: [
        {
            key: 1,
            label: "Leave Summary",
            route: "summary",
            leftIcon: <BookOutlined className={'left-icon'}/>,
            rightIcon: <RightOutlined className={'right-icon'}/>,
            className: "leave-summary"
        },
        {
            key: 2,
            label: "Leave Entitlement",
            route: "entitlement",
            leftIcon: <BookOutlined className={'left-icon'}/>,
            rightIcon: <RightOutlined className={'right-icon'}/>,
            className: "leave-entitlement",
        },
        {
            key: 3,
            label: "Leave Request & Approvals",
            route: "approvals",
            leftIcon: <BookOutlined className={'left-icon'}/>,
            rightIcon: <RightOutlined className={'right-icon'}/>,
            className: "leaveApplication",
        }
    ],
    employee: [
        {
            key: 1,
            label: "My Leave Summary",
            route: "summary",
            leftIcon: <BookOutlined className={'left-icon'}/>,
            rightIcon: <RightOutlined className={'right-icon'}/>,
            className: "leave-summary"
        },
        {
            key: 3,
            label: "My Leave Request",
            route: "request",
            leftIcon: <BookOutlined className={'left-icon'}/>,
            rightIcon: <RightOutlined className={'right-icon'}/>,
            className: "leaveRequest",
        }
    ],
    supervisor: [
        {
            key: 1,
            label: "My Leave Summary",
            route: "summary",
            leftIcon: <BookOutlined className={'left-icon'}/>,
            rightIcon: <RightOutlined className={'right-icon'}/>,
            className: "leave-summary"
        },
        {
            key: 3,
            label: "My Leave Request",
            route: "request",
            leftIcon: <BookOutlined className={'left-icon'}/>,
            rightIcon: <RightOutlined className={'right-icon'}/>,
            className: "leaveRequest",
        },
        {
            key: 4,
            label: "Leave For Approvals",
            route: "approvals",
            leftIcon: <BookOutlined className={'left-icon'}/>,
            rightIcon: <RightOutlined className={'right-icon'}/>,
            className: "leaveApplication",
        },
        {
            key: 5,
            label: "Team Leave Summary",
            route: "team-summary",
            leftIcon: <BookOutlined className={'left-icon'}/>,
            rightIcon: <RightOutlined className={'right-icon'}/>,
            className: "leave-summary"
        },

    ]
}


function EmployeeLeave() {
    const {user} = useContext(UserLoginContext);
    const isAdmin = user?.isAdmin || false;
    const [tabView, setTabView] = useState<any>([]);
    const [supervisorDetail, setSupervisorDetail] = useState<ISupervisor>({
        empId: '',
        isSupervisor: false
    })
    const location = useLocation();
    const activeRoute = location.pathname.split("/").pop();
    const checkIfTabActive = (tabRoute: string) => activeRoute === tabRoute;
    const [leaveTypeTable, setLeaveTypeTable] = useState({
        key: 1,
        label: "",
        route: "",
        leftIcon: <BookOutlined className={'left-icon'}/>,
        rightIcon: <RightOutlined className={'right-icon'}/>,
        className: ""
    });

    useEffect(() => {
        if (!user) return;
        if (isAdmin) {
            setTabView(leaveSidebarItems.admin);
            setSupervisorDetail({
                empId: user.employeeId || '',
                isSupervisor: false,
            });
            //tab-route match and set it
            const currTab = leaveSidebarItems.admin.find((i: any) => i.route === activeRoute);
            setLeaveTypeTable(prev => currTab ? currTab : leaveSidebarItems.admin[0]);
            return;
        }

        const fetchManagerStatus = async () => {
            let isSupervisor = false;
            try {
                if (!user.employeeId) return;
                isSupervisor = await server.employee.checkReportingManagerStatus(user.employeeId);
                setSupervisorDetail({
                    empId: user.employeeId,
                    isSupervisor,
                });
            } catch (error) {
                console.error("Error fetching manager status:", error);
            }

            const newTabs = isSupervisor
                ? leaveSidebarItems.supervisor
                : leaveSidebarItems.employee;
            setTabView(newTabs);
            const currTab = newTabs.find((i: any) => i.route === activeRoute);
            setLeaveTypeTable(prev => currTab ? currTab : newTabs[0]);
        };

        fetchManagerStatus();
    }, [user, isAdmin]);

    const LeaveSidebar = () => {
        return (
            <ul className={'sidebar-item-list'}>
                {tabView.map((item: any, key: any) => {
                    return (
                        <li id={item.key}
                            className={`sidebar-item ${item.className}` + (checkIfTabActive(item.route) ? " active" : "")}
                            key={item.key}>
                            <Link to={item.route}
                                  onClick={() => {
                                      setLeaveTypeTable(item);
                                  }}
                            >
                                {item.leftIcon}
                                {item.label}
                                {item.rightIcon}
                            </Link>
                        </li>
                    )
                })
                }
            </ul>
        )
    }

    const isPersonalSummary = !isAdmin && leaveTypeTable.route === 'summary';

    return (
        <Layout className="leave-management page-layout leave">
            <header className={"leave-application page-layout__heading"}>
                <h3 className="title">
                    Leave Planner
                </h3>
            </header>
            <div className="leave-management page-layout__content">
                <LeaveContext.Provider value={{supervisor: supervisorDetail, isPersonalSummary, isAdmin}}>
                    <div className="leave-management page-layout__sidebar">
                        <LeaveSidebar/>
                    </div>
                    <div className="leave-management page-layout__table">
                        {/*<h3 className="title">{leaveTypeTable.label}</h3>*/}
                        <Outlet/>
                    </div>
                </LeaveContext.Provider>
            </div>
        </Layout>
    );
}

export default EmployeeLeave;
